<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary px-6 py-10">
      <p
        @click="handleBack"
        class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
      >
        <feather-icon class="flex" icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
        Go Back
      </p>
      <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
        My Assets
      </h2>
    </div>

    <div class="flex w-full menucontrol-scroll fixed-top bg-white">
      <div class="relative w-full">
        <div class="p-8">
          <div class="heigh-tab w-full">
            <div class="grid grid-cols-2 gap-8 w-full pb-8">
              <!-- @click="handleClick(item)" -->
              <div
                class="flex items-start border rounded-10px cursor-pointer p-4"
                @click="handleClick(item)"
                v-for="(item, index) in getrequest.data"
                :key="index"
              >
                <div class="w-9/12 flex items-center gap-2">
                  <div>
                    <img
                      :src="showImage(item.request.image)"
                      class="object-contain wh-75px rounded-10px p-3 bg-cas"
                      alt="banh"
                    />
                  </div>
                  <div class="pl-4">
                    <h2 class="col-4f text-xl mb-0 font-semibold">
                      {{ item.request.name }}
                    </h2>
                    <div v-if="item.request.isDeducted">
                      <p
                        class="font-mediu pt-2 fsize12 text-8f8f8f flex items-center"
                      >
                        x {{ item.quantity }}
                      </p>
                    </div>
                    <p class="font-mediu fsize12 text-8f8f8f flex items-center">
                      {{ getDate(item.deliveredDate) }}
                    </p>

                    <div
                      v-if="
                        item.hasOwnProperty('feedback') && item.feedback.length
                      "
                    >
                      <el-rate
                        v-if="item.feedback[1]"
                        v-model="item.feedback[1].feedbackRating"
                      ></el-rate>
                      <el-rate
                        v-else
                        v-model="item.feedback[0].feedbackRating"
                      ></el-rate>
                    </div>
                  </div>
                </div>
                <div class="w-3/12">
                  <div class="flex justify-end">
                    <p
                      class="bg-light-green fsize10 flex justify-center border-round py-1 px-4"
                    >
                      {{ item.status }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="heigh-tab flex justify-center">
            <div class="text-center mt-32">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/file.svg"
                alt="image"
                class="w-3/5"
              />
              <h2 class="font-semibold fsize20 mt-4">No data Available</h2>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <el-pagination
      background
      @current-change="
        (value) => {
          currentPage = value;
          getAllAssets();
        }
      "
      layout="prev,pager,next"
      :total="pageCount"
    ></el-pagination>
  </div>
</template>

<script>
import Plans3 from "@/views/adminPanel/pages/ecommerce/components/Plans3";
import { mapState } from "vuex";

import moment from "moment";
export default {
  data() {
    return {
      value1: "",
      feedbacks: [],
      pageCount: 0,
      currentPage: 1,
    };
  },
  components: {
    Plans3,
  },
  methods: {
    async handleClick(item) {
      if (!item.request.isDeducted) {
        this.$store.commit("studio/SELECTED_REQUEST", item);
        this.$store.commit("studio/PREVIOUS_ROUTE", "studio-Myassets");
        this.$router.push({ name: "studio-chat" });
      }
    },

    showImage(value) {
      let default_image = require("@/assets/images/card1.png");

      return value
        ? `${process.env.VUE_APP_IMAGE_URL}/${value}`
        : default_image;
    },
    async getAllAssets() {
      let loader = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let offset = 0;
      let getReq = await this.$store.dispatch("studio/getRequest", {
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
        // requestId: this.createrequest._id,
        paginated: true,
        offset: 10 * this.currentPage - 10,
        status: ["Delivered", "Signed Off"],
        deliveredDate: true,
      });

      this.pageCount = getReq.data.count;
      // for (let i = 0; i <= getReq.data.length; i++) {
      //   this.feedbacks =
      // }
      loader.close();
    },
    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
  },
  computed: {
    ...mapState("studio", ["getrequest"]),
    ...mapState("user", ["selectedProject"]),
  },
  mounted() {
    this.getAllAssets();
  },
};
</script>
